// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multi-scoped[data-v-48d1af34] .multiselect__tags{border:1px solid #ced4da}.multi-scoped[data-v-48d1af34] .multiselect__content-wrapper li:last-of-type{display:none!important}", ""]);
// Exports
module.exports = exports;
